<div
  class="ais-RefinementList toggleWidget"
  *ngIf="
    state?.value?.onFacetValue?.count > 0 &&
    (!isLocalCountries || sustainableLeafOn) &&
    (!isdealsEligible || currentDeal?.active)
  "
  [ngClass]="{'toggleWidget--sustainable': sustainableLeafOn && (isDirectShipping || isLocalCountries)}"
>
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header toggleWidget__header"
      [ngClass]="{
        'ais-RefinementList-header--closed': !showRefinementBody,
        'ais-RefinementList-header--shorter': sustainableLeafOn && (isDirectShipping || isLocalCountries)
      }"
      (click)="toggleShowBody()"
    >
      <span *ngIf="options.label === 'DELIVERY_OPTS.EXPRESS'" i18n="@@DELIVERY_OPTS.EXPRESS">Express Delivery</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.DS'" i18n="@@CATALOG.FILTERS.DS">Direct Shipping</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.LOCAL_COUNTRIES'">{{ marketingFilterLocal?.title }}</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.DEALS_ELIGIBLE'">{{ dealsName }}</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.OFFICIALSTORE'" i18n="@@PRODUCT.DESCRIPTION.BRAND_STORE"
        >Brand Store</span
      >
    </button>
  </div>
  <div
    class="ais-RefinementList-body ais-body toggleWidget__listContainer"
    [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}"
  >
    <ul class="ais-RefinementList-list">
      <li *ngIf="state && state.value && state.value.onFacetValue">
        <input
          id="toggle__{{ state.value.name + '_on' }}"
          class="filters_checkbox_input toggleWidget__input"
          type="checkbox"
          (change)="refineToggle($event, state.value)"
          [checked]="state.value.onFacetValue.isRefined ? 'checked' : null"
          [attr.aria-checked]="state.value.onFacetValue.isRefined || false"
        />
        <!-- LABELS -->
        <ng-container [ngSwitch]="state?.value?.onFacetValue?.name">
          <!-- EXPRES DELIVERY -->
          <label
            *ngSwitchCase="'stock_on'"
            for="toggle__{{ state.value?.name + '_on' }}"
            class="filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else stockLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="stockLabel"></ng-template>
            </a>
            <ng-template #stockLabel i18n="@@CATALOG.FILTERS.STOCK_24">
              Items shipped within 24 hours
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
          </label>

          <!-- DIRECT SHIPPING -->
          <label
            *ngSwitchCase="'dsEligibleCountries_on'"
            for="toggle__{{ state.value?.name + '_on' }}"
            class="filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else dsLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="dsLabel"></ng-template>
            </a>
            <ng-template #dsLabel>
              <ng-container
                *ngIf="sustainableLeafOn; else oldDirectShippingTex"
                i18n="@@REGULAR_FILTER_DS.SUSTAINABLE_LEAF.TEXT"
              >
                Cut your item’s journey in half to save on CO2 and costs
              </ng-container>
              <ng-template #oldDirectShippingTex i18n="@@CATALOG.FILTERS.DS_LABEL"
                >Items eligible for Direct Shipping</ng-template
              >
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
          </label>

          <!-- LOCAL COUNTRIES -->
          <label
            *ngSwitchCase="'localCountries_on'"
            for="toggle__{{ state?.value?.name + '_on' }}"
            class="filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else localLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="localLabel"></ng-template>
            </a>
            <ng-template #localLabel>
              <span i18n="@@REGULAR_FILTER_LOCAL.SUSTAINABLE_LEAF.TEXT">
                Buy in your region for shorter shipping distances</span
              >
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state?.value?.onFacetValue?.count }})</span>
          </label>

          <!-- DEALS ELIGIBLE -->
          <label
            *ngSwitchCase="'editorPicks.dealEligible_on'"
            for="toggle__{{ state?.value?.name + '_on' }}"
            class="filters_checkbox_label toggleWidget__label"
          >
            <a *ngIf="seoUrl; else dealLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="dealLabel"></ng-template>
            </a>
            <ng-template #dealLabel>
              <span i18n="@@CATALOG.FILTERS.DEALS_LABEL"> Show {{ dealsName }}</span>
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state?.value?.onFacetValue?.count }})</span>
          </label>

          <!-- BRAND STORE BADGE -->
          <label
            *ngSwitchCase="'seller.isOfficialStore_on'"
            for="toggle__{{ state.value?.name + '_on' }}"
            class="filters_checkbox_label"
          >
            <a *ngIf="seoUrl; else brandLabel" [href]="seoUrl">
              <ng-template *ngTemplateOutlet="brandLabel"></ng-template>
            </a>
            <ng-template #brandLabel i18n="@@CATALOG.FILTERS.BS_LABEL">
              Display Brand Store items
            </ng-template>
            <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
          </label>
        </ng-container>
      </li>
    </ul>
  </div>
  <vc-catalog-sustainable
    *ngIf="sustainableLeafOn && (isDirectShipping || isLocalCountries)"
    [isMobile]="isMobile"
    [type]="options.facet"
    [localFilterName]="marketingFilterLocal?.title"
  ></vc-catalog-sustainable>
</div>
